;(function ($) {
  "use strict";

  var timer;

  $(document).ready(function () {

    // detect if IE11 and below
    if (detectIE() != false && detectIE() <= 11) {
      // hack svg holder for responsive behaviour
      svgIEFix();
    }

    $(window).on('resize.svgIEFix', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        svgIEFix();
      }, 200);
    });
  });
})(jQuery);

function detectIE() {
  var ua = window.navigator.userAgent;

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}

function svgIEFix() {
  $('#main-page-content .svg-holder svg').each(function (i) {
    var svgElem = ($(this));

    svgElem.css({
      'width': '',
      'height': '',
      'padding-bottom': ''
    });

    var boxSizeAspect = (svgElem[0].viewBox.baseVal.height / svgElem[0].viewBox.baseVal.width) * 100;
    var containerAspect = (svgElem.parent('.svg-holder').height() / svgElem.parent('.svg-holder').width()) * 100;

    if (containerAspect > boxSizeAspect) {
      svgElem.css({
        'overflow': 'visible',
        'width': '100%',
        'height': '1px',
        'padding-bottom': boxSizeAspect + '%'
      });
    } else {
      svgElem.attr('preserveAspectRatio', 'xMidYMin slice');

      svgElem.css({
        'overflow': 'visible',
        'width': ((svgElem.parent('.svg-holder').height() / boxSizeAspect) * 100) + 'px',
        'height': '100%',
        'padding-bottom': ''
      });
    }
  });
}
